// Footer.js
import React from "react";
import styled from "styled-components";
import { FaFacebookF, FaWhatsapp, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const FooterContainer = styled.footer`
  background-color: #ea384c;
  color: white;
  padding: 40px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  text-align: left;
`;

const FooterColumn = styled.div`
  flex: 1;
  min-width: 250px;
  margin-bottom: 20px;
`;

const FooterTitle = styled.h3`
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
`;

const FooterText = styled.p`
  font-size: 14px;
  line-height: 1.5;
`;

const FooterList = styled.ul`
  list-style: none;
  padding: 0;
`;

const FooterItem = styled.li`
  margin: 5px 0;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

const SocialIcon = styled.a`
  background-color: white;
  color: #ea384c;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 18px;
  width: 35px;
  height: 35px;
  transition: 0.3s;

  &:hover {
    background-color: red;
    color: white;
  }
`;

const ContactForm = styled.form`
  display: flex;
  margin-top: 10px;
`;

const EmailInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-radius: 5px;
  font-size: 14px;
`;

const SubmitButton = styled.button`
  background-color: white;
  color: #ea384c;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 5px;
  font-weight: bold;

  &:hover {
    background-color: red;
    color: white;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      {/* Contact Information */}
      <FooterColumn>
        <FooterTitle>Contact Us</FooterTitle>
        <FooterText>Email: richmantembo@gmail.com</FooterText>
        <FooterText>Phone: +263 77 581 6439</FooterText>
        <FooterText>Address: 123 Church Emganwini, Bulawayo</FooterText>
      </FooterColumn>

      {/* Get Help */}
      <FooterColumn>
        <FooterTitle>Get Help</FooterTitle>
        <FooterList>
          <FooterItem>FAQs</FooterItem>
          <FooterItem>Prayer Requests</FooterItem>
          <FooterItem>Support</FooterItem>
          <FooterItem>Community Services</FooterItem>
        </FooterList>
      </FooterColumn>

      {/* Preview Categories */}
      <FooterColumn>
        <FooterTitle>Preview Categories</FooterTitle>
        <FooterList>
          <FooterItem>Sermons</FooterItem>
          <FooterItem>Events</FooterItem>
          <FooterItem>Ministries</FooterItem>
          <FooterItem>Blog</FooterItem>
        </FooterList>
      </FooterColumn>

      {/* Get in Touch */}
      <FooterColumn>
        <FooterTitle>Get in Touch</FooterTitle>
        <ContactForm>
          <EmailInput type="email" placeholder="Enter your email" required />
          <SubmitButton type="submit">Submit</SubmitButton>
        </ContactForm>
        <SocialIcons>
          <SocialIcon href="#" target="_blank"><FaFacebookF /></SocialIcon>
          <SocialIcon href="#" target="_blank"><FaWhatsapp /></SocialIcon>
          <SocialIcon href="#" target="_blank"><FaLinkedinIn /></SocialIcon>
          <SocialIcon href="#" target="_blank"><FaInstagram /></SocialIcon>
        </SocialIcons>
      </FooterColumn>
    </FooterContainer>
  );
};

export default Footer;
